// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var component = ReasonReact.statelessComponent("Link");

function make(href, label, className, _) {
  var handleClick = function () {
    return ReasonReact.Router[/* push */0](href);
  };
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("a", {
                  className: className,
                  onClick: handleClick
                }, label);
    });
  return newrecord;
}

exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/link.re
// module id = 13
// module chunks = 0